<template>
	<div class="messages container">
		<div class="row mb-8">
			<div class="col-12">
				<h1>{{ $t("new-message") }}</h1>
			</div>
		</div>
		<div class="row" v-if="users.length">
			<div class="col-12 col-lg-8">
				<template v-if="!$route.params.threadid">
					<div class="clearfix mb-4">
						<div
							class="pseudo-input"
							:class="{ error: recipientsError }"
							data-cy="message-recipients"
						>
							<input
								type="search"
								class="input-bare w-full flex-1"
								data-cy="message-user-search"
								:placeholder="$t('to-colon')"
								v-if="!recipients.length"
								@click="openModal"
							/>
							<span
								class="badge badge-secondary badge-sm mr-2 mb-2"
								v-for="(recipient, index) in recipients"
								v-bind:key="index"
							>
								{{ recipient.displayName }}
								<a @click="removeRecipient(recipient)"><b-icon icon="x"></b-icon></a>
							</span>
							<span
								class="badge badge-primary badge-sm mr-2 mb-2"
								v-if="recipients.length"
								@click="openModal"
							>
								<b-icon icon="plus"></b-icon> {{ $t("add") }}
							</span>
							<span
								class="badge badge-danger badge-sm mr-2 mb-2"
								v-if="recipients.length"
								@click="recipients=[]"
							>
								<b-icon icon="x"></b-icon> {{ $t('clear-all') }}
							</span>
						</div>
						<span class="text-error" v-if="recipientsError">{{
							$t("please-select-at-least-one-user")
						}}</span>
						<!-- <button
	            class="btn btn-info mr-2 mb-4"
	            v-for="(recipient, index) in recipients"
	            v-bind:key="index"
	            @click="removeRecipient(recipient)"
	          >
	            {{ recipient.DisplayName }}
	            <b-icon icon="x"></b-icon>
	          </button> -->
					</div>
					<div class="clearfix" v-if="$UserSession.hasPriv('MESSAGE_STUDENTS') && $UserSession.hasPriv('MESSAGE_MULTISELECT')">
						<template v-for="programme in $config.getValue('programmes')">
							<button
								class="btn btn-info mr-2 mb-4"
								v-for="year in parseInt(programme.CourseLengthYears) + 1"
								:key="`${programme.Name}-${year}`"
								@click="
									addRecipientsBy({ programme: programme.Id, year: year.toString() })
								"
							>
								{{ programme.Name }}
								<template v-if="year <= parseInt(programme.CourseLengthYears)">
									{{ $t("year") }} {{ year }}
								</template>
								<template v-else>{{ $t('graduated') }}</template>
							</button>
						</template>

						<button
							class="btn btn-info mr-2 mb-4"
							@click="addRecipientsBy({ isStudent: true })"
						>
							{{ $tc("all-students", 1) }}
						</button>
						<button
							class="btn btn-info mr-2 mb-4"
							@click="addRecipientsBy({ isTeacher: true })"
						>
							{{ $tc("all-teachers", 1) }}
						</button>
					</div>
					<input
						class="form-control mb-4"
						type="text"
						v-model="subject"
						data-cy="message-subject"
						:placeholder="$t('subject')"
					/>
				</template>
				<textarea
					class="form-control"
					:class="{ error: errors.message }"
					style="height: 200px"
					v-model="content"
					data-cy="message-content"
					:placeholder="$t('message')"
					name="message"
					required
					v-validate
				></textarea>
				<div class="text-error">{{ errors.message }}</div>

				<div class="form-check mt-3">
					<label class="form-check-label" for="important">
						<input type="checkbox" class="form-check-input" id="important" v-model="important">
							{{ $t('mark-as-important') }}
					</label>
				</div>
				<button class="btn btn-primary mt-4" @click="sendMessage" data-cy="send-message-button">{{ $t('send-message') }}</button>
			</div>
			<!--
      <div class="col-4">
        <aside class="aside">
          <h2>Recipients</h2>
        </aside>
      </div> -->
		</div>
	</div>
</template>

<script>
import { ValidateMixin } from "@/mixins";
export default {
	mixins: [ValidateMixin],
	data: function() {
		return {
			subject: "",
			content: "",
			recipients: [],
			recipientsError: false,
			users: [],
			important: false
		}
	},
	mounted() {
		// by default, can only message teachers
		const promises = [this.$users.getTeachers.call(this)];
		// can message students if has the priv
		if (this.$UserSession.hasPriv("MESSAGE_STUDENTS")) {
			promises.push(this.$users.getStudents.call(this));
		}
		Promise.all(promises).then(values => {
			// merge teacher/student arrays
			this.users = [].concat.apply([], values);
		});
	},
	methods: {
		addRecipientsBy(filter) {
			this.recipients = [
				...this.recipients,
				...this.users.filter(user => {
					for (let key in filter) {
						if (user[key] === undefined || user[key] != filter[key]) return false;
					}
					return !this.recipients.some(
						recipient => recipient.id == user.id // don't add recipients that have already been added
					);
				})
			];
		},
		openModal() {
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t("select-recipients"),
				selectCallback: function(selection) {
					const isSelected = self.recipients.find((recipient, i) => {
						if (recipient.id === selection.id) {
							self.$delete(self.recipients, i);
							return true;
						}
					});
					if (!isSelected) {
						self.recipients.push(selection);
					}
					self.recipientsError = false;
				},
				selected: this.recipients,
				data: this.users,
				captionKey: "displayName",
				studentSearchFilters: this.$UserSession.hasPriv("MESSAGE_STUDENTS"),
				selectAllBtn: (this.$UserSession.hasPriv("MESSAGE_STUDENTS") && this.$UserSession.hasPriv("MESSAGE_MULTISELECT"))
			});
		},
		removeRecipient(selection) {
			const self = this;
			self.recipients.find((student, i) => {
				if (student.id === selection.id) {
					self.$delete(self.recipients, i);
					return true;
				}
			});
			return false;
		},
		sendMessage() {
			this.validate();

			this.recipientsError = !this.recipients.length && !this.$route.params.threadid;
			// todo: would like to integrate this into v-validate somehow
			if (this.hasErrors || this.recipientsError) {
				return false;
			}

			if (this.recipients.length || this.$route.params.threadid) {
				var message = {
					subject: this.subject,
					content: this.content,
					to: [],
					important: this.important
				}
				for(let recipient of this.recipients){
					message.to.push(recipient.id);
				}
				const data = {
					message
				}
				if(this.$route.params.threadid) {
					data.thread_id = this.$route.params.threadid
				}
				if(this.$route.query.replyto) {
					data.replyto = this.$route.query.replyto;
				}

				this.$cfetch(`${this.$settings.APIBaseURL}/messages/send`,
					{
						method: "post",
						data
					}
				)
					.then(json => {
						if (json.status == "SUCCESS") {
							this.$store.commit("openDialog", {
								title: this.$t("message-sent"),
								content: this.$t("your-message-has-been-sent"),
								cypressId: "message-sent",
								confirmCallBack: function() {
									this.$router.replace("/messages/list");
								}
							});
						} else {
							this.$store.commit("openDialog", this.$t("could-not-send-message"));
						}
					})
					.catch(error => {
						this.$log.error.call(this, error);
						this.$store.commit("openDialog", this.$t("could-not-send-message"));
					});
			} else {
				this.$store.commit("openDialog", this.$t("no-recipients-specified"));
			}
		}
	}
};
</script>
